<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row>
                <b-col>
                    <b-card border-variant="primary">
                        <template slot = "header">
                            <i class='fa fa-align-justify'></i>
                            Notice_Test
                            <span class = "float-right">
                                <strong>{{ model.created_at | date }}</strong>
                            </span>
                        </template>
                        <b-row>
                            <b-col>
                                <label for = "type">
                                    Solution : 
                                </label>
                                <select :disabled = "lock" v-model = "model.type">
                                    <option disabled value = "">Please select solution</option>
                                    <option value="wfdetect">WFDetector : Detect and respond to forgery of web pagess</option>
                                    <option value="wmds">WMDS : Web Malware Detection System</option>
                                    <option value="wsfinder">WSFinder : WeShell Finder</option>
                                    <option value="webcastle">WEBCastle : Web Firewall</option>
                                    <option value="etc">Etc</option>
                                    <option value="release">Release</option>
                                </select>
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col md = "8">
                                <b-form-group>
                                    <label for = "title">
                                        Title : 
                                    </label>
                                    <b-form-input type = "text" id = "title" :disabled = "lock" v-model = "model.title"></b-form-input>
                                </b-form-group>
                            </b-col>                         
                        </b-row>
                        <b-row>
                            <b-col md = "12">
                                <vue-editor v-model = "model.content" :disabled = "lock" id = "content"></vue-editor>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-button size = "sm" v-if = "!lock" variant = "info text-light" @click = "save">Submit</b-button>
                        <b-button size = "sm" v-else variant = "warning text-light" @click = "edit">Edit</b-button>
                        <b-button size = "sm" v-if = "lock && model.id" variant = "danger" @click = "confirm = true">Remove</b-button>
                        <b-button size = "sm" class = "float-right" variant = "dark text-light" @click = "list">List</b-button>
                        <b-button size = "sm" class = "float-right mr-2 text-light" v-if = "!lock && !add" variant = "secondary" @click = "cancel">Cancel</b-button>
                    </b-card>
                </b-col>
            </b-row>
            <b-modal title = "Do you want to delete this content?" class = "modal-danger" v-model = "confirm" @ok = "remove(modal)" ok-variant="danger">
                If you want to delete this content, please click "OK" button.
            </b-modal>
        </div>
    </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { Api } from '@/service';

export default {
    components: { VueEditor },

    data: () => ({
            lock: true, add: false, model: { type : '' }, confirm: false,
        }
    ),

    methods : {
        list() {
            this.$router.push({ name: 'notice_test' });
        },

        edit() {
            this.lock = false;
        },

        cancel() {
            this.lock = true;       //lock =  true 이면 다시 edit 로 넘어감.
        },

        //id 가 add 인지 아닌지 판별
        async get(id = this.$route.params.id) {
            console.log('notice_test.detail.vue', 'load item', id);

            if(id !== 'add') {
                try {
                    let rs = await Api.Manager_Call('board.notice', 'detail', { id : id });
                    this.model = Object.assign({}, this.model, rs.body );

                    return;
                } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
            }else {
                this.add = true;
            }

            this.lock = false;
        },

        async save(){
            if(_.isEmpty(this.model.type && this.model.type.value ? this.model.type.value : this.model.type)) {
                return this.$toastr.e('Please select Solution');
            }
            if(_.isEmpty(this.model.title)) {
                return this.$toastr.e('Please input Title');
            }
            if(_.isEmpty(this.model.content)) {
                return this.$toastr.e('Please input Content');
            }

            try{
                let model = Object.assign({}, this.model, { type : this.model.type.value ? this.model.type.value : this.model.type })

                let rs = await Api.Manager_Call('board.notice', this.model.id ? 'update' : 'insert', model);

                if(!rs.error) {
                    this.$toastr.s('Save success', this.$route.name)

                    this.$emit("refresh")

                    this.lock = true; 
                } else {
                    this.$toastr.e('Saved', 'failed')
                }
            }catch(e){
                this.$toastr.e('Saved error')
            }
        },

        remove() {
             try{
                let rs = Api.Manager_Call('board.notice', 'remove', { id: this.model.id });

                if(!rs.error) {
                    this.$toastr.s('remove success')

                    this.$emit("refresh");
                } else {
                    this.$toastr.s('remove failed')
                }

                this.list();

                this.$emit("refresh")          
            }catch(e){
                this.$toastr.e('remove error')
            }
        },
    },

    watch: {
        '$router' (to, from) {
            this.get(to.params.id);
            console.log(`from : ${from}`);
        }
    },

    created(){
        console.log('notice_test.detail.vue', 'created');
    },
    destroyed(){
        console.log('notice_test.detail.vue', 'destroyed');
    },
    mounted(){
        console.log('notice_test.detail.vue', 'mounted');
        this.get(this.$route.params.id);
    },
}
</script>